var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{staticStyle:{"height":"200px"},attrs:{"data":_vm.data,"options":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }